<template>
    <div class="sms-request">
        <p class="section-hint">СМС-рассылка предполагает рассылку по абонентской базе TELE2. Цены включают НДС.</p>

        <div class="sms-request__body">
            <div class="sms-request__audience">
                <div class="field sms-request__audience-gender" data-field="gender">
                    <span class="field__label">Пол</span>
                    <div class="sms-request__checks sms-request__checks--stack">
                        <label class="sms-request__option">
                            <input
                                type="checkbox"
                                class="creative-checkbox"
                                :checked="menChecked"
                                :disabled="disabled"
                                @change="setGender('m', $event.target.checked)"
                            />
                            <span>Мужчины</span>
                        </label>
                        <label class="sms-request__option">
                            <input
                                type="checkbox"
                                class="creative-checkbox"
                                :checked="womenChecked"
                                :disabled="disabled"
                                @change="setGender('f', $event.target.checked)"
                            />
                            <span>Женщины</span>
                        </label>
                    </div>
                    <p v-if="fieldError('gender')" class="field__error">{{ fieldError('gender') }}</p>
                </div>

                <div class="field sms-request__audience-age" data-field="age_from">
                    <span class="field__label">Возраст</span>
                    <div class="sms-request__age">
                        <label class="sms-request__option">
                            <input v-model="ageAll" type="checkbox" class="creative-checkbox" :disabled="disabled" />
                            <span>Все 18+</span>
                        </label>
                        <label class="sms-request__age-bound">
                            <span>от</span>
                            <input
                                :value="ageFromDisplay"
                                type="number"
                                min="18"
                                max="75"
                                class="form-input"
                                :disabled="disabled || ageAll"
                                @input="setAge('age_from', $event)"
                            />
                        </label>
                        <label class="sms-request__age-bound">
                            <span>до</span>
                            <input
                                :value="ageToDisplay"
                                type="number"
                                min="18"
                                max="75"
                                class="form-input"
                                :disabled="disabled || ageAll"
                                data-field="age_to"
                                @input="setAge('age_to', $event)"
                            />
                        </label>
                    </div>
                    <p v-if="fieldError('age_from') || fieldError('age_to')" class="field__error">
                        {{ fieldError('age_from') || fieldError('age_to') }}
                    </p>
                </div>
            </div>

            <div class="sms-request__region">
                <div class="field sms-request__region-cities" data-field="cities">
                    <span class="field__label">Регион / город</span>
                    <p v-if="!cities.length" class="section-hint section-hint--warn">
                        Список городов ещё не задан.
                    </p>
                    <div v-else class="sms-request__checks sms-request__checks--stack">
                        <label v-for="city in cities" :key="city.value" class="sms-request__option">
                            <input
                                type="checkbox"
                                class="creative-checkbox"
                                :checked="request.cities.includes(String(city.value))"
                                :disabled="disabled"
                                @change="toggle('cities', city.value)"
                            />
                            <span>{{ city.label }}</span>
                        </label>
                    </div>
                    <p v-if="fieldError('cities')" class="field__error">{{ fieldError('cities') }}</p>
                </div>
                <div class="field sms-request__region-map" data-field="geo_points">
                    <span class="field__label">Геолокация</span>
                    <SmsGeoPicker
                        :points="request.geo_points"
                        :places="selectedCityPlaces"
                        :disabled="disabled"
                        @update="onGeo"
                    />
                    <p v-if="fieldError('geo_points')" class="field__error">{{ fieldError('geo_points') }}</p>
                </div>
            </div>

            <div class="sms-request__profile">
                <div class="field">
                    <span class="field__label">Доход абонента</span>
                    <div class="sms-request__checks sms-request__checks--stack">
                        <label v-for="option in incomes" :key="option.value" class="sms-request__option">
                            <input
                                type="checkbox"
                                class="creative-checkbox"
                                :checked="request.incomes.includes(String(option.value))"
                                :disabled="disabled"
                                @change="toggle('incomes', option.value)"
                            />
                            <span>{{ option.label }}</span>
                        </label>
                    </div>
                </div>

                <div class="field">
                    <span class="field__label">Наличие авто</span>
                    <div class="sms-request__checks sms-request__checks--stack">
                        <label v-for="option in triOptions" :key="`car-${option.value}`" class="sms-request__option">
                            <input v-model="carValue" type="radio" :value="option.value" :disabled="disabled" />
                            <span>{{ option.label }}</span>
                        </label>
                    </div>
                </div>

                <div class="field">
                    <span class="field__label">Роуминг за предыдущий год</span>
                    <div class="sms-request__checks sms-request__checks--stack">
                        <label v-for="option in triOptions" :key="`roaming-${option.value}`" class="sms-request__option">
                            <input v-model="roamingValue" type="radio" :value="option.value" :disabled="disabled" />
                            <span>{{ option.label }}</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="sms-request__devices">
                <div class="field sms-request__devices-brand">
                    <span class="field__label">Бренд устройства</span>
                    <div class="sms-request__checks sms-request__checks--stack">
                        <label v-for="option in deviceBrands" :key="option.value" class="sms-request__option">
                            <input
                                type="checkbox"
                                class="creative-checkbox"
                                :checked="request.device_brands.includes(String(option.value))"
                                :disabled="disabled"
                                @change="toggle('device_brands', option.value)"
                            />
                            <span>{{ option.label }}</span>
                        </label>
                    </div>
                </div>

                <div class="field sms-request__devices-apps">
                    <span class="field__label">Приложения</span>
                    <div class="sms-request__checks sms-request__checks--stack">
                        <label v-for="option in appCategories" :key="option.value" class="sms-request__option">
                            <input
                                type="checkbox"
                                class="creative-checkbox"
                                :checked="request.app_categories.includes(String(option.value))"
                                :disabled="disabled"
                                @change="toggle('app_categories', option.value)"
                            />
                            <span>{{ option.label }}</span>
                        </label>
                    </div>
                </div>
            </div>

            <fieldset class="fieldset fieldset--info sms-request__message">
                <legend>Сообщение</legend>
                <div class="field" data-field="sender_id">
                    <label class="field__label" for="sms-sender">Буквенный идентификатор</label>
                    <input
                        id="sms-sender"
                        v-model="request.sender_id"
                        type="text"
                        maxlength="11"
                        class="form-input"
                        placeholder="LatinName"
                        :disabled="disabled"
                        :class="{ 'is-invalid': fieldError('sender_id') }"
                    />
                    <p class="section-hint">Буквенный идентификатор - наименование отправителя сообщения, до 11-символов на латинице</p>
                    <p v-if="fieldError('sender_id')" class="field__error">{{ fieldError('sender_id') }}</p>
                </div>

                <div class="sms-request__pair" data-field="send_date_from">
                    <label class="field">
                        <span class="field__label">Дата начала</span>
                        <input v-model="request.send_date_from" type="date" class="form-input" :disabled="disabled" />
                        <p v-if="fieldError('send_date_from')" class="field__error">{{ fieldError('send_date_from') }}</p>
                    </label>
                    <label class="field" data-field="send_date_to">
                        <span class="field__label">Дата окончания</span>
                        <input v-model="request.send_date_to" type="date" class="form-input" :disabled="disabled" />
                        <p v-if="fieldError('send_date_to')" class="field__error">{{ fieldError('send_date_to') }}</p>
                    </label>
                </div>

                <div class="field" data-field="send_slots">
                    <span class="field__label">Окна отправки</span>
                    <div class="sms-request__checks">
                        <label v-for="slot in sendSlotOptions" :key="slot.value" class="sms-request__option">
                            <input
                                type="checkbox"
                                class="creative-checkbox"
                                :checked="(request.send_slots || []).includes(String(slot.value))"
                                :disabled="disabled"
                                @change="toggle('send_slots', slot.value)"
                            />
                            <span>{{ slot.label }}</span>
                        </label>
                    </div>
                    <p v-if="fieldError('send_slots')" class="field__error">{{ fieldError('send_slots') }}</p>
                </div>

                <div class="field" data-field="text_ru">
                    <label class="field__label" for="sms-text-ru">Текст, русский</label>
                    <textarea
                        id="sms-text-ru"
                        v-model="request.text_ru"
                        class="form-input"
                        rows="3"
                        maxlength="1000"
                        :disabled="disabled"
                    />
                    <p v-if="fieldError('text_ru')" class="field__error">{{ fieldError('text_ru') }}</p>
                </div>

                <div class="field" data-field="text_kz">
                    <label class="field__label" for="sms-text-kz">Текст, казахский</label>
                    <textarea
                        id="sms-text-kz"
                        v-model="request.text_kz"
                        class="form-input"
                        rows="3"
                        maxlength="1000"
                        :disabled="disabled"
                    />
                    <p v-if="fieldError('text_kz')" class="field__error">{{ fieldError('text_kz') }}</p>
                </div>

                <div data-field="sms_count">
                    <div class="sms-request__pair">
                        <label class="field">
                            <span class="field__label">Количество SMS, русский</span>
                            <input
                                id="sms-count-ru"
                                v-model.number="request.sms_count"
                                type="number"
                                min="1"
                                step="1"
                                class="form-input"
                                :disabled="disabled"
                            />
                        </label>
                        <label class="field">
                            <span class="field__label">Количество SMS, казахский</span>
                            <input
                                id="sms-count-kz"
                                v-model.number="request.sms_count"
                                type="number"
                                min="1"
                                step="1"
                                class="form-input"
                                :disabled="disabled"
                            />
                        </label>
                    </div>
                    <p class="section-hint">Одинаковое для обоих языков.</p>
                    <p v-if="fieldError('sms_count')" class="field__error">{{ fieldError('sms_count') }}</p>
                </div>
            </fieldset>

            <div v-if="isEdit" class="sms-request__send">
                <button
                    type="button"
                    class="btn btn--primary"
                    :disabled="disabled || sending"
                    @click="emit('send')"
                >
                    {{ sending ? 'Отправка…' : 'Отправить заявку' }}
                </button>
                <p v-if="sendError" class="field__error">{{ sendError }}</p>
                <p v-if="deliveryLine" class="section-hint">{{ deliveryLine }}</p>
            </div>
            <p v-else class="section-hint">Отправка заявки доступна после сохранения.</p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import SmsGeoPicker from '../campaigns/SmsGeoPicker.vue';

const props = defineProps({
    request: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    sending: { type: Boolean, default: false },
    sendError: { type: String, default: '' },
    lastDelivery: { type: Object, default: null },
    cities: { type: Array, default: () => [] },
    incomes: { type: Array, default: () => [] },
    deviceBrands: { type: Array, default: () => [] },
    appCategories: { type: Array, default: () => [] },
    sendSlots: { type: Array, default: () => [] },
});

const emit = defineEmits(['send']);

const sendSlotOptions = computed(() => (props.sendSlots.length ? props.sendSlots : [
    { value: '9-13', label: '9:00–13:00' },
    { value: '13-17', label: '13:00–17:00' },
    { value: '17-21', label: '17:00–21:00' },
]));

const triOptions = [
    { value: '', label: 'Не задано' },
    { value: 'yes', label: 'Да' },
    { value: 'no', label: 'Нет' },
];

const fieldError = (name) => props.errors[name] || '';

const selectedCityPlaces = computed(() => props.cities
    .filter((city) => props.request.cities.includes(String(city.value)))
    .map((city) => ({ lat: Number(city.lat), lng: Number(city.lng) }))
    .filter((place) => Number.isFinite(place.lat) && Number.isFinite(place.lng)));

const toggle = (key, value) => {
    const id = String(value);
    const list = props.request[key];
    const index = list.findIndex((item) => String(item) === id);
    if (index === -1) list.push(id);
    else list.splice(index, 1);
};

const genderIncludes = (code) => props.request.gender === 'all' || props.request.gender === code;
const menChecked = computed(() => genderIncludes('m'));
const womenChecked = computed(() => genderIncludes('f'));

const setGender = (code, checked) => {
    const men = code === 'm' ? checked : genderIncludes('m');
    const women = code === 'f' ? checked : genderIncludes('f');
    if (men && women) props.request.gender = 'all';
    else if (men) props.request.gender = 'm';
    else if (women) props.request.gender = 'f';
    else props.request.gender = '';
};

const ageAll = computed({
    get: () => props.request.age_from == null && props.request.age_to == null,
    set: (checked) => {
        if (checked) {
            props.request.age_from = null;
            props.request.age_to = null;
            return;
        }
        props.request.age_from = 18;
        props.request.age_to = 75;
    },
});

const ageFromDisplay = computed(() => (ageAll.value ? 18 : (props.request.age_from ?? '')));
const ageToDisplay = computed(() => (ageAll.value ? 75 : (props.request.age_to ?? '')));

const setAge = (key, event) => {
    if (ageAll.value) return;
    const raw = event.target.value;
    props.request[key] = raw === '' ? null : Number(raw);
};

const triValue = (key) => computed({
    get: () => (props.request[key] === true ? 'yes' : props.request[key] === false ? 'no' : ''),
    set: (value) => {
        props.request[key] = value === 'yes' ? true : value === 'no' ? false : null;
    },
});

const roamingValue = triValue('roaming');
const carValue = triValue('has_car');

const onGeo = (points) => {
    props.request.geo_points = points;
};

const deliveryLine = computed(() => {
    const delivery = props.lastDelivery;
    if (!delivery) return '';
    const when = delivery.sent_at || delivery.created_at || '';
    if (delivery.status === 'sent') return `Последняя отправка: ${when}`;
    return `Не отправлено${when ? ` (${when})` : ''}: ${delivery.error || 'ошибка Telegram'}`;
});
</script>

<style scoped lang="scss">
.sms-request__check {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    cursor: pointer;
}

.sms-request__region {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 16px 24px;
}

.sms-request__region-cities {
    flex: 0 0 220px;
}

.sms-request__region-map {
    flex: 1 1 320px;
    min-width: 260px;
}

.sms-request__audience {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 24px 32px;
}

.sms-request__audience-gender {
    flex: 0 0 auto;
}

.sms-request__audience-age {
    flex: 1 1 240px;
}

.sms-request__profile,
.sms-request__devices {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 16px 24px;

    > .field {
        margin: 0;
    }
}

.sms-request__profile > .field {
    flex: 1 1 180px;
}

.sms-request__devices-brand {
    flex: 0 1 240px;
}

.sms-request__devices-apps {
    flex: 1 1 320px;
    min-width: 260px;
}

.sms-request__body {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 8px;
}

.sms-request__checks {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
}

.sms-request__checks--stack {
    flex-direction: column;
    align-items: flex-start;
}

.sms-request__option {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.sms-request__age {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 20px;
}

.sms-request__age-bound {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    .form-input {
        width: 88px;
    }
}

.sms-request__pair {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;

    .field {
        flex: 1;
        min-width: 160px;
        margin: 0;
    }
}

.sms-request__message {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.sms-request__send {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.creative-checkbox {
    width: 18px;
    height: 18px;
    min-width: 18px;
    margin: 0;
    accent-color: #2563eb;
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
    }
}

textarea.form-input {
    width: 100%;
    resize: vertical;
}
</style>
